import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=DM+Sans:wght@300;400;500&display=swap');
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
:root { --gold: #c9a84c; --gold-light: #e8c97a; --dark: #0a0a0a; --g-blue: #4285F4; --g-red: #EA4335; --g-yellow: #FBBC04; --g-green: #34A853; }
.wa-page {
  min-height: 100vh; width: 100vw;
  background: radial-gradient(ellipse 100% 80% at 50% 20%, #0d0d0d 0%, #050505 100%);
  display: flex; align-items: center; justify-content: center;
  font-family: 'DM Sans', sans-serif; overflow: hidden; position: relative;
}
.bg-glow { position: fixed; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(66,133,244,0.06) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%, -50%); pointer-events: none; transition: background 1s ease; }
.bg-glow.success { background: radial-gradient(circle, rgba(52,168,83,0.1) 0%, transparent 70%); }
.stage { display: flex; flex-direction: column; align-items: center; gap: 32px; position: relative; z-index: 2; transform-origin: center center; }
@media (max-width: 360px), (max-height: 620px) { .stage { transform: scale(0.78); gap: 20px; } }
@media (min-width: 361px) and (max-width: 480px) and (min-height: 621px) { .stage { transform: scale(0.9); } }
.card-preview {
  width: 300px; border-radius: 20px; overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.7), 0 0 0 1px rgba(201,168,76,0.15);
  position: relative; transition: transform 0.5s ease, opacity 0.5s ease;
  background: linear-gradient(145deg, #e8f0fe 0%, #d2e3fc 50%, #e8f4f8 100%);
}
/* Pass header — dark navy */
.card-top {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 16px 16px 14px; display: flex; align-items: center; gap: 12px;
  position: relative; overflow: hidden;
}
.card-top::before {
  content: ''; position: absolute; inset: 0;
  background-image: linear-gradient(rgba(66,133,244,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(66,133,244,0.1) 1px, transparent 1px);
  background-size: 16px 16px; opacity: 0.5;
}
.card-avatar {
  width: 52px; height: 52px; border-radius: 50%;
  border: 2.5px solid rgba(201,168,76,0.75);
  box-shadow: 0 0 14px rgba(201,168,76,0.4);
  background: linear-gradient(135deg, #3a2a10, #5c3d00);
  display: flex; align-items: center; justify-content: center;
  font-size: 24px; flex-shrink: 0; position: relative; z-index: 1;
}
.card-name-block { flex: 1; position: relative; z-index: 1; }
.card-name { font-family: 'Cinzel', serif; font-size: 15px; font-weight: 600; color: var(--gold-light); letter-spacing: 0.06em; line-height: 1.2; }
.card-company { font-size: 9px; color: rgba(255,255,255,0.45); letter-spacing: 0.12em; text-transform: uppercase; margin-top: 3px; }
.card-wallet-badge { display: flex; flex-direction: column; align-items: flex-end; gap: 3px; position: relative; z-index: 1; }
.card-wallet-text { font-size: 8px; color: rgba(255,255,255,0.35); letter-spacing: 0.05em; }
.card-wallet-dots { display: flex; gap: 2px; }
.cwd { width: 6px; height: 6px; border-radius: 50%; }
/* Pass body */
.card-body { padding: 16px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
.card-designation { font-size: 22px; font-weight: 300; color: #1a1a2e; letter-spacing: 0.02em; text-align: center; line-height: 1.3; }
.card-divider { width: 80%; height: 1px; background: linear-gradient(90deg, transparent, rgba(66,133,244,0.3), transparent); }
.qr-wrap { background: white; border-radius: 12px; padding: 12px; width: 130px; height: 130px; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
.qr-svg { width: 90px; height: 90px; }
.qr-scan-label { font-size: 9px; color: rgba(26,26,46,0.45); letter-spacing: 0.15em; text-transform: uppercase; }
/* Pass footer */
.card-footer {
  background: linear-gradient(135deg, rgba(66,133,244,0.08), rgba(52,168,83,0.05));
  padding: 10px 16px; display: flex; align-items: center; justify-content: space-between;
  border-top: 1px solid rgba(66,133,244,0.15);
}
.card-footer-text { font-size: 8px; color: rgba(26,26,46,0.45); letter-spacing: 0.06em; }
.card-footer-badge { font-size: 7px; background: #34A853; color: white; padding: 3px 8px; border-radius: 10px; letter-spacing: 0.06em; font-weight: 600; }
.wallet-btn { width: min(260px, 90vw); height: 46px; background: #1a1a1a; border: 1px solid rgba(255,255,255,0.12); border-radius: 12px; display: flex; align-items: center; justify-content: center; gap: 10px; cursor: pointer; font-size: 13px; color: rgba(255,255,255,0.85); letter-spacing: 0.05em; transition: all 0.3s ease; position: relative; overflow: hidden; user-select: none; font-family: 'DM Sans', sans-serif; }
.wallet-btn:hover { border-color: rgba(66,133,244,0.5); box-shadow: 0 0 20px rgba(66,133,244,0.15); transform: translateY(-2px); }
.wallet-btn:active { transform: scale(0.97); }
.google-dots { display: flex; gap: 2px; }
.g-dot { width: 8px; height: 8px; border-radius: 50%; }
.wallet-btn-shine { position: absolute; top: 0; left: -100%; width: 60%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent); animation: shine-loop 3s 1s infinite; }
@keyframes shine-loop { 0% { left: -100%; } 100% { left: 200%; } }
.overlay { position: fixed; inset: 0; background: rgba(0,0,0,0); z-index: 10; display: flex; align-items: center; justify-content: center; pointer-events: none; transition: background 0.4s ease; }
.overlay.active { background: rgba(0,0,0,0.85); pointer-events: all; }
.anim-container { position: relative; display: flex; flex-direction: column; align-items: center; gap: 0; }
.phone-mock { width: 260px; height: 520px; background: #111; border-radius: 36px; border: 2px solid #2a2a2a; box-shadow: 0 40px 100px rgba(0,0,0,0.9), 0 0 0 1px #333; overflow: hidden; position: relative; opacity: 0; transform: translateY(60px) scale(0.9); transition: opacity 0.5s ease, transform 0.5s cubic-bezier(0.22,1,0.36,1); }
.phone-mock.visible { opacity: 1; transform: translateY(0) scale(1); }
.phone-mock::before { content: ''; position: absolute; top: 10px; left: 50%; transform: translateX(-50%); width: 80px; height: 18px; background: #0a0a0a; border-radius: 12px; z-index: 20; }
.phone-screen { width: 100%; height: 100%; background: #f0f4ff; display: flex; flex-direction: column; }
.phone-topbar { height: 44px; background: #f0f4ff; display: flex; align-items: center; padding: 0 14px; gap: 10px; margin-top: 28px; border-bottom: 1px solid rgba(0,0,0,0.06); }
.topbar-back { color: #4285F4; font-size: 18px; font-weight: 300; }
.topbar-title { font-size: 13px; color: #333; font-weight: 500; flex: 1; }
.topbar-icons { display: flex; gap: 12px; color: #555; font-size: 14px; }
.wallet-pass { margin: 12px; border-radius: 16px; background: linear-gradient(145deg, #e8f0fe 0%, #d2e3fc 50%, #e8f4f8 100%); box-shadow: 0 8px 24px rgba(66,133,244,0.2), 0 2px 6px rgba(0,0,0,0.08); overflow: hidden; position: relative; opacity: 0; transform: translateY(20px); transition: opacity 0.6s 0.3s ease, transform 0.6s 0.3s cubic-bezier(0.22,1,0.36,1); }
.wallet-pass.visible { opacity: 1; transform: translateY(0); }
.pass-header { background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); padding: 14px 16px 12px; display: flex; align-items: center; gap: 10px; position: relative; overflow: hidden; }
.pass-header::before { content: ''; position: absolute; inset: 0; background-image: linear-gradient(rgba(66,133,244,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(66,133,244,0.1) 1px, transparent 1px); background-size: 16px 16px; opacity: 0.5; }
.pass-avatar { width: 52px; height: 52px; border-radius: 50%; border: 2.5px solid rgba(201,168,76,0.7); box-shadow: 0 0 14px rgba(201,168,76,0.4); background: linear-gradient(135deg, #3a2a10, #5c3d00); display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; position: relative; z-index: 1; opacity: 0; transform: scale(0.5); transition: opacity 0.5s 0.7s ease, transform 0.5s 0.7s cubic-bezier(0.34,1.56,0.64,1); }
.pass-avatar.visible { opacity: 1; transform: scale(1); }
.pass-name-block { flex: 1; position: relative; z-index: 1; opacity: 0; transform: translateX(-10px); transition: opacity 0.5s 0.9s ease, transform 0.5s 0.9s ease; }
.pass-name-block.visible { opacity: 1; transform: translateX(0); }
.pass-name { font-family: 'Cinzel', serif; font-size: 15px; color: var(--gold-light); letter-spacing: 0.06em; }
.pass-company { font-size: 9px; color: rgba(255,255,255,0.5); letter-spacing: 0.12em; text-transform: uppercase; margin-top: 2px; }
.pass-google-logo { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: flex-end; gap: 3px; opacity: 0; transition: opacity 0.4s 1.1s ease; }
.pass-google-logo.visible { opacity: 1; }
.google-w-text { font-size: 8px; color: rgba(255,255,255,0.4); letter-spacing: 0.05em; }
.google-color-dots { display: flex; gap: 2px; }
.gcd { width: 6px; height: 6px; border-radius: 50%; }
.pass-body { padding: 14px 16px; display: flex; flex-direction: column; align-items: center; gap: 10px; }
.pass-designation { font-size: 19px; font-weight: 300; color: #1a1a2e; letter-spacing: 0.02em; text-align: center; opacity: 0; transform: translateY(8px); transition: opacity 0.5s 1.1s ease, transform 0.5s 1.1s ease; }
.pass-designation.visible { opacity: 1; transform: translateY(0); }
.pass-divider { width: 80%; height: 1px; background: linear-gradient(90deg, transparent, rgba(66,133,244,0.3), transparent); opacity: 0; transition: opacity 0.4s 1.3s ease; }
.pass-divider.visible { opacity: 1; }
.pass-qr-wrap { background: white; border-radius: 10px; padding: 10px; width: 110px; height: 110px; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0,0,0,0.1); opacity: 0; transform: scale(0.7) rotate(-5deg); transition: opacity 0.6s 1.4s ease, transform 0.6s 1.4s cubic-bezier(0.34,1.56,0.64,1); }
.pass-qr-wrap.visible { opacity: 1; transform: scale(1) rotate(0deg); }
.pass-scan-label { font-size: 9px; color: rgba(26,26,46,0.5); letter-spacing: 0.15em; text-transform: uppercase; opacity: 0; transition: opacity 0.4s 1.9s ease; }
.pass-scan-label.visible { opacity: 1; }
.pass-footer { background: linear-gradient(135deg, rgba(66,133,244,0.08), rgba(52,168,83,0.05)); padding: 10px 16px; display: flex; align-items: center; justify-content: space-between; border-top: 1px solid rgba(66,133,244,0.15); opacity: 0; transition: opacity 0.5s 2.0s ease; }
.pass-footer.visible { opacity: 1; }
.pass-footer-text { font-size: 8px; color: rgba(26,26,46,0.45); letter-spacing: 0.08em; }
.pass-footer-badge { font-size: 7px; background: #34A853; color: white; padding: 2px 7px; border-radius: 10px; letter-spacing: 0.08em; }
.success-ring { position: absolute; bottom: -24px; left: 50%; width: 48px; height: 48px; border-radius: 50%; background: #34A853; display: flex; align-items: center; justify-content: center; box-shadow: 0 0 24px rgba(52,168,83,0.5); opacity: 0; transform: translateX(-50%) scale(0); transition: opacity 0.4s 2.3s ease, transform 0.5s 2.3s cubic-bezier(0.34,1.56,0.64,1); z-index: 30; }
.success-ring.visible { opacity: 1; transform: translateX(-50%) scale(1); }
.check-icon { font-size: 22px; }
.toast { position: fixed; bottom: 40px; left: 50%; transform: translateX(-50%) translateY(80px); background: #1e1e1e; border: 1px solid rgba(52,168,83,0.4); border-radius: 12px; padding: 12px 22px; display: flex; align-items: center; gap: 10px; font-size: 12px; color: rgba(255,255,255,0.85); letter-spacing: 0.05em; z-index: 100; opacity: 0; transition: opacity 0.4s 2.5s ease, transform 0.5s 2.5s cubic-bezier(0.22,1,0.36,1); white-space: nowrap; box-shadow: 0 8px 32px rgba(0,0,0,0.5); }
.toast.visible { opacity: 1; transform: translateX(-50%) translateY(0); }
.toast-dot { width: 8px; height: 8px; border-radius: 50%; background: #34A853; flex-shrink: 0; }
.ripple { position: absolute; border-radius: 50%; background: rgba(66,133,244,0.3); transform: scale(0); animation: ripple-out 0.6s ease-out forwards; pointer-events: none; }
@keyframes ripple-out { to { transform: scale(4); opacity: 0; } }
.wallet-btn.loading { border-color: rgba(66,133,244,0.5); pointer-events: none; }
.loading-dots { display: none; gap: 4px; align-items: center; }
.loading-dots span { width: 6px; height: 6px; border-radius: 50%; background: var(--g-blue); animation: dot-bounce 0.8s infinite ease-in-out both; }
.loading-dots span:nth-child(2) { background: var(--g-red); animation-delay: 0.15s; }
.loading-dots span:nth-child(3) { background: var(--g-yellow); animation-delay: 0.3s; }
.loading-dots span:nth-child(4) { background: var(--g-green); animation-delay: 0.45s; }
@keyframes dot-bounce { 0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; } 40% { transform: scale(1); opacity: 1; } }
.btn-default-content { display: flex; align-items: center; gap: 10px; }
`;

const QR_SVG = (
    <svg className="qr-svg" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="5" width="26" height="26" fill="none" stroke="#000" strokeWidth="3"/><rect x="11" y="11" width="14" height="14" fill="#000"/>
        <rect x="59" y="5" width="26" height="26" fill="none" stroke="#000" strokeWidth="3"/><rect x="65" y="11" width="14" height="14" fill="#000"/>
        <rect x="5" y="59" width="26" height="26" fill="none" stroke="#000" strokeWidth="3"/><rect x="11" y="65" width="14" height="14" fill="#000"/>
        <rect x="35" y="5" width="5" height="5" fill="#000"/><rect x="43" y="5" width="5" height="5" fill="#000"/>
        <rect x="51" y="5" width="5" height="5" fill="#000"/><rect x="35" y="13" width="5" height="5" fill="#000"/>
        <rect x="51" y="13" width="5" height="5" fill="#000"/><rect x="43" y="21" width="5" height="5" fill="#000"/>
        <rect x="35" y="35" width="5" height="5" fill="#000"/><rect x="43" y="35" width="5" height="5" fill="#000"/>
        <rect x="51" y="35" width="5" height="5" fill="#000"/><rect x="59" y="35" width="5" height="5" fill="#000"/>
        <rect x="35" y="43" width="5" height="5" fill="#000"/><rect x="51" y="43" width="5" height="5" fill="#000"/>
        <rect x="35" y="51" width="5" height="5" fill="#000"/><rect x="43" y="51" width="5" height="5" fill="#000"/>
        <rect x="59" y="51" width="5" height="5" fill="#000"/><rect x="67" y="43" width="5" height="5" fill="#000"/>
        <rect x="75" y="35" width="5" height="5" fill="#000"/><rect x="67" y="51" width="5" height="5" fill="#000"/>
        <rect x="75" y="43" width="5" height="5" fill="#000"/><rect x="43" y="59" width="5" height="5" fill="#000"/>
        <rect x="51" y="67" width="5" height="5" fill="#000"/><rect x="59" y="59" width="5" height="5" fill="#000"/>
        <rect x="67" y="67" width="5" height="5" fill="#000"/><rect x="75" y="59" width="5" height="5" fill="#000"/>
        <rect x="43" y="75" width="5" height="5" fill="#000"/><rect x="59" y="75" width="5" height="5" fill="#000"/>
        <rect x="75" y="75" width="5" height="5" fill="#000"/>
    </svg>
);

export default function WalletAnimationPage() {
    const navigate = useNavigate();
    const bgGlowRef = useRef(null);
    const overlayRef = useRef(null);
    const phoneMockRef = useRef(null);
    const walletPassRef = useRef(null);
    const walletBtnRef = useRef(null);
    const loadingDotsRef = useRef(null);
    const btnDefaultRef = useRef(null);
    const toastRef = useRef(null);
    const timers = useRef([]);

    const reveal = (ids, delay = 0) => {
        const t = setTimeout(() => {
            ids.forEach(id => document.getElementById(`wa-${id}`)?.classList.add("visible"));
        }, delay);
        timers.current.push(t);
    };

    useEffect(() => {
        // Auto-trigger wallet animation after 3s so user can see the card + button first
        const startTimer = setTimeout(() => {
            triggerAnimation();
        }, 3000);
        timers.current.push(startTimer);

        // Navigate to /create after full animation (~8.5s total from page load)
        const navTimer = setTimeout(() => navigate("/create"), 8500);
        timers.current.push(navTimer);

        return () => timers.current.forEach(clearTimeout);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const triggerAnimation = () => {
        // Ripple on button
        const btn = walletBtnRef.current;
        if (btn) {
            const ripple = document.createElement("div");
            ripple.className = "ripple";
            const size = Math.max(btn.offsetWidth, btn.offsetHeight);
            ripple.style.cssText = `width:${size}px;height:${size}px;left:${btn.offsetWidth/2 - size/2}px;top:${btn.offsetHeight/2 - size/2}px`;
            btn.appendChild(ripple);
            setTimeout(() => ripple.remove(), 700);
            btn.classList.add("loading");
            if (btnDefaultRef.current) btnDefaultRef.current.style.display = "none";
            if (loadingDotsRef.current) loadingDotsRef.current.style.display = "flex";
        }

        // After 1.2s open overlay
        const t = setTimeout(() => {
            if (loadingDotsRef.current) loadingDotsRef.current.style.display = "none";
            if (btnDefaultRef.current) btnDefaultRef.current.style.display = "flex";
            if (btn) btn.classList.remove("loading");
            openOverlay();
        }, 1200);
        timers.current.push(t);
    };

    const openOverlay = () => {
        if (overlayRef.current) overlayRef.current.classList.add("active");

        reveal(["phoneMock"], 100);
        reveal(["walletPass"], 400);
        reveal(["passAvatar"], 700);
        reveal(["passNameBlock"], 900);
        reveal(["passGoogleLogo", "passDesignation"], 1100);
        reveal(["passDivider"], 1300);
        reveal(["passQr"], 1400);
        reveal(["passScanLabel"], 1900);
        reveal(["passFooter"], 2000);
        reveal(["successRing"], 2300);

        const t1 = setTimeout(() => { if (bgGlowRef.current) bgGlowRef.current.classList.add("success"); }, 2300);
        const t2 = setTimeout(() => { if (toastRef.current) toastRef.current.classList.add("visible"); }, 2500);
        timers.current.push(t1, t2);
    };

    return (
        <div className="wa-page">
            <style dangerouslySetInnerHTML={{ __html: CSS }} />
            <div className="bg-glow" ref={bgGlowRef} />

            <div className="stage">
                <div className="card-preview">
                    {/* Dark header — wallet pass style */}
                    <div className="card-top">
                        <div className="card-avatar">🧑‍💻</div>
                        <div className="card-name-block">
                            <div className="card-name">Your Card</div>
                            <div className="card-company">Your Company</div>
                        </div>
                        <div className="card-wallet-badge">
                            <div className="card-wallet-text">Google Wallet</div>
                            <div className="card-wallet-dots">
                                <div className="cwd" style={{ background: "#4285F4" }} />
                                <div className="cwd" style={{ background: "#EA4335" }} />
                                <div className="cwd" style={{ background: "#FBBC04" }} />
                                <div className="cwd" style={{ background: "#34A853" }} />
                            </div>
                        </div>
                    </div>
                    {/* Light body */}
                    <div className="card-body">
                        <div className="card-designation">Your Title</div>
                        <div className="card-divider" />
                        <div className="qr-wrap">{QR_SVG}</div>
                        <div className="qr-scan-label">Scan to view profile</div>
                    </div>
                    {/* Footer */}
                    <div className="card-footer">
                        <span className="card-footer-text">myprofilecorner.com/you</span>
                        <span className="card-footer-badge">✓ VERIFIED</span>
                    </div>
                </div>

                <button className="wallet-btn" ref={walletBtnRef}>
                    <div className="wallet-btn-shine" />
                    <div className="btn-default-content" ref={btnDefaultRef}>
                        <div className="google-dots">
                            <div className="g-dot" style={{ background: "#4285F4" }} />
                            <div className="g-dot" style={{ background: "#EA4335" }} />
                            <div className="g-dot" style={{ background: "#FBBC04" }} />
                            <div className="g-dot" style={{ background: "#34A853" }} />
                        </div>
                        Add to Google Wallet
                    </div>
                    <div className="loading-dots" ref={loadingDotsRef}>
                        <span /><span /><span /><span />
                    </div>
                </button>
            </div>

            {/* Overlay */}
            <div className="overlay" ref={overlayRef}>
                <div className="anim-container">
                    <div className="phone-mock" id="wa-phoneMock" ref={phoneMockRef}>
                        <div className="phone-screen">
                            <div className="phone-topbar">
                                <span className="topbar-back">←</span>
                                <span className="topbar-title">Google Wallet</span>
                                <div className="topbar-icons"><span>⋮</span></div>
                            </div>
                            <div className="wallet-pass" id="wa-walletPass" ref={walletPassRef}>
                                <div className="pass-header">
                                    <div className="pass-avatar" id="wa-passAvatar">🧑‍💻</div>
                                    <div className="pass-name-block" id="wa-passNameBlock">
                                        <div className="pass-name">Your Card</div>
                                        <div className="pass-company">Your Company</div>
                                    </div>
                                    <div className="pass-google-logo" id="wa-passGoogleLogo">
                                        <div className="google-w-text">Google Wallet</div>
                                        <div className="google-color-dots">
                                            <div className="gcd" style={{ background: "#4285F4" }} />
                                            <div className="gcd" style={{ background: "#EA4335" }} />
                                            <div className="gcd" style={{ background: "#FBBC04" }} />
                                            <div className="gcd" style={{ background: "#34A853" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="pass-body">
                                    <div className="pass-designation" id="wa-passDesignation">Your Title</div>
                                    <div className="pass-divider" id="wa-passDivider" />
                                    <div className="pass-qr-wrap" id="wa-passQr">{QR_SVG}</div>
                                    <div className="pass-scan-label" id="wa-passScanLabel">Scan to view profile</div>
                                </div>
                                <div className="pass-footer" id="wa-passFooter">
                                    <span className="pass-footer-text">myprofilecorner.com/you</span>
                                    <span className="pass-footer-badge">✓ VERIFIED</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="success-ring" id="wa-successRing">
                        <span className="check-icon">✓</span>
                    </div>
                </div>
            </div>

            <div className="toast" id="wa-toast" ref={toastRef}>
                <div className="toast-dot" />
                Pass added to Google Wallet
            </div>
        </div>
    );
}
